<script setup>
import {computed, onUnmounted} from 'vue'
import {useRoute} from 'vue-router'
import {useOdpReportsStore} from '@/stores/odpReports'

const route = useRoute()
const odpReportsStore = useOdpReportsStore()

const formData = computed(() => odpReportsStore.formData)

const monthsAgo = route.query.monthsAgo || ''
formData.value.monthsAgo = monthsAgo

onUnmounted(() => {
    delete formData.value.monthsAgo
})
</script>

<template>
    <select
        required
        v-model="formData.monthsAgo"
        class="form-select form-select-sm"
        name="months_ago"
        oninvalid="this.setCustomValidity('Please select a date range')"
        oninput="this.setCustomValidity('')"
    >
        <option value="">Select&hellip;</option>
        <option
            v-for="(text, value) in { 1: '1 month', 3: '3 months', 6: '6 months', 12: '12 months', 24: '24 months' }"
            :key="value"
            :value="value"
        >
            {{ text }}
        </option>
    </select>
</template>